import React from 'react';
import { Provider } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

const loadDevTools = () =>
    process.env.NODE_ENV === 'development' && typeof window !== 'undefined' && window.devToolsExtension
        ? window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
        : (func) => func;

const store = createStore(rootReducer, compose(applyMiddleware(thunk), loadDevTools()));

const ReduxWrapper = ({ children }) => <Provider store={store}>{children}</Provider>;

export default ReduxWrapper;
